export default {
  list: {
    name: 'String',
    contact: {
      company: 'String',
      address1: 'String',
      address2: 'String',
      city: 'String',
      state: 'String',
      zip: 'String',
      country: 'String',
      phone: 'String',
    },
    permission_reminder: 'String',
    use_archive_bar: 'Boolean',
    campaign_defaults: {
      from_name: 'String',
      from_email: 'String',
      subject: 'String',
      language: 'String',
    },
    notify_on_subscribe: 'String',
    notify_on_unsubscribe: 'String',
    email_type_option: 'Boolean',
    visibility: 'String',
    double_optin: 'String',
    marketing_permissions: 'String',
  },
  mergeField: {
    tag: 'String',
    name: 'String',
    type: 'String',
    required: 'Boolean',
    default_value: 'String',
    public: 'Boolean',
    display_order: 'Number',
    help_test: 'String',
    options: {
      default_country: 'Number',
      phone_format: 'String',
      date_format: 'String',
      choices: 'Array',
      size: 'Number',
    },
  },
  signupForm: {
    header: {
      image_url: 'String',
      text: 'String',
      image_width: 'String',
      image_height: 'String',
      image_alt: 'String',
      image_link: 'String',
      image_align: 'String',
      image_border_width: 'String',
      image_border_style: 'String',
      image_border_color: 'String',
      image_targe: 'String',
    },
    contents: [{
      section: 'String',
      value: 'String',
    }],
    styles: [{
      selector: 'String',
      options: [{
        property: 'String',
        value: 'String',
      }],
    }],
  },
  webhook: {
    url: 'String',
    events: {
      subscribe: true,
      unsubscribe: true,
      profile: true,
      cleaned: true,
      upemail: true,
      campaign: true,
    },
    sources: {
      user: true,
      admin: true,
      api: true,
    },
  },
}
